import jquery from 'jquery';
window.jQuery = jquery;
window.$ = jquery;


import 'bootstrap';
import 'choices.js'
import '@github/relative-time-element';
import 'owl.carousel';

import Cookies from 'js-cookie'
window.Cookies = Cookies;

// Components
import './components/dropdowns';
import './components/navbar';
import './components/choices';
import './components/tooltip';
import './components/toast';
import './components/validation';
import './components/buttons';
import './components/accordian';
import './components/simple-mde';
import './components/list';
import './components/flatpickr';
import './components/file-input';
import './components/sort';
import './components/clipboard';
import './components/temp-modal';
import './components/tab';
import './components/bootstrap';
